import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, detailText } from "@/lib/api";
import { applyTheme } from "@/lib/themes";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [state, setState] = useState({ loading: true, user: null, membership: null, wedding: null, isAdmin: false, accountBlocked: null });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setState({ loading: false, user: data.user, membership: data.membership, wedding: data.wedding, isAdmin: !!data.is_admin, accountBlocked: null });
      if (data.wedding?.theme_id) applyTheme(data.wedding.theme_id);
      return data;
    } catch (e) {
      const status = e?.response?.status;
      // 403 dari masa aktif = akun kedaluwarsa, harus tampilkan halaman
      // khusus, bukan diperlakukan sebagai "belum login".
      if (status === 403) {
        setState({ loading: false, user: null, membership: null, wedding: null, isAdmin: false, accountBlocked: detailText(e?.response?.data?.detail) || "Masa aktif akun Anda telah habis." });
        return null;
      }
      setState({ loading: false, user: null, membership: null, wedding: null, isAdmin: false, accountBlocked: null });
      return null;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setState({ loading: false, user: null, membership: null, wedding: null, isAdmin: false, accountBlocked: null });
    window.location.href = "/login";
  };

  return (
    <AuthCtx.Provider value={{ ...state, refresh, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
